import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  standalone: false,
})
export class LogoComponent {
  @Input() showText: boolean = false;
  @Input() clickable: boolean = true;

  constructor(private router: Router) {}

  navigateHome() {
    if (!this.clickable) {
      return;
    }
    void this.router.navigate(['/admin', 'home']);
  }
}
